import { EMedicalViews, ERectangleVariantNames, EViewOptions, TimelineVariantProps } from '~/interfaces/timeline'
import { EHealthProceduresTypes } from '~/interfaces/healthProcedures'
import { theme } from '~/styles'

export const HealthProcedureVariantProps: TimelineVariantProps<EHealthProceduresTypes> = {
  [EHealthProceduresTypes.ANATOMOPATHOLOGICAL_TEST]: { color: theme.colors.color923AC5, iconName: 'microscope' },
  [EHealthProceduresTypes.IMAGING_TEST]: { color: theme.colors.color1f6ecd, iconName: 'xRay' },
  [EHealthProceduresTypes.ECHOCARDIOGRAM_TEST]: { color: theme.colors.color1f6ecd, iconName: 'xRay' },
  [EHealthProceduresTypes.RADIOLOGY_IMAGING_TEST]: { color: theme.colors.color1f6ecd, iconName: 'xRay' },
  [EHealthProceduresTypes.MATERNAL_INFANT_IMAGING_TEST]: { color: theme.colors.color1f6ecd, iconName: 'xRay' },
  [EHealthProceduresTypes.VACCINE]: { color: theme.colors.color3A9FC5, iconName: 'syringe' },
  [EHealthProceduresTypes.LABORATORY_TEST]: { color: theme.colors.color3AC5B5, iconName: 'erlenmeyerFlask' },
  [EHealthProceduresTypes.MEDICAL_APPOINTMENT]: { color: theme.colors.colorA9C53A, iconName: 'stethoscope' },
  [EHealthProceduresTypes.MEDICAL_NOTE]: { color: theme.colors.color21C7DA, iconName: 'clipboardMedical' },
  [EHealthProceduresTypes.SURGERY]: { color: theme.colors.colorC58A3A, iconName: 'surgery' },
  [EHealthProceduresTypes.BIRTH]: { color: theme.colors.color5be1f6, iconName: 'birthMeasurement' },
  [EHealthProceduresTypes.EVALUATION_BREAST_IMAGING_TEST]: {
    color: theme.colors.colorEA5DA9,
    iconName: 'breastfeeding'
  },
  [EHealthProceduresTypes.DIAGNOSIS_BIOPSY]: { color: theme.colors.colorEB0052, iconName: 'hypodermicSyringe' },
  [EHealthProceduresTypes.DIAGNOSIS_ANATOMOPATHOLOGICAL_TEST]: {
    color: theme.colors.color923AC5,
    iconName: 'microscope'
  },
  // TODO: remove admission from here
  [EHealthProceduresTypes.DIAGNOSIS]: { color: theme.colors.colorEA5DA9, iconName: 'breast' },
  [EHealthProceduresTypes.ADMISSION]: { color: theme.colors.colorC5B73A, iconName: 'hospitalBed' }
}

export const RectangleVariantProps: TimelineVariantProps<ERectangleVariantNames> = {
  [ERectangleVariantNames.OMICS]: { color: theme.colors.colorc5683a, iconName: 'layerGroup' },
  [ERectangleVariantNames.CONDUCT]: { color: theme.colors.colorC5B73A, iconName: 'hospitalBed' },
  [ERectangleVariantNames.DIAGNOSIS]: { color: theme.colors.colorEA5DA9, iconName: 'breast' }
}

export const SelectMedicalViewsOptions = {
  [EMedicalViews.GENERAL]: 'Geral',
  [EMedicalViews.MATERNAL_INFANT]: 'Materno-Infantil',
  [EMedicalViews.RADIOLOGY]: 'Radiologia',
  [EMedicalViews.LABORATORY]: 'Laboratório',
  [EMedicalViews.ONCOLOGY]: 'Câncer de Mama'
}

export const SelectViewOptions = {
  [EViewOptions.HUMAN_BODY]: 'Corpo Humano',
  [EViewOptions.TIMELINE]: 'Linha do Tempo'
}
